module.exports = __webpack_public_path__ + "img/archive-add.86011895.svg";